import React from "react";
import LegalLayout from "@/components/honex/LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout
      title="Datenschutz­erklärung"
      subtitle="Informationen gemäß Art. 13 DSGVO"
    >
      <h2>1. Verantwortlicher</h2>
      <p>
        Verantwortlicher für die Datenverarbeitung auf dieser Website ist:
      </p>
      <p>
        Honex GmbH<br />
        Ilhan Honsic (Geschäftsführer)<br />
        Max-Keith-Str. 66, 45136 Essen<br />
        Telefon: 0201 43355633<br />
        E-Mail: info@honexbau.de
      </p>

      <h2>2. Allgemeine Hinweise</h2>
      <p>
        Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und behandeln Ihre
        personenbezogenen Daten vertraulich und entsprechend der gesetzlichen
        Datenschutzvorschriften (insbesondere DSGVO und BDSG) sowie dieser
        Datenschutzerklärung.
      </p>

      <h2>3. Erhebung von Daten beim Besuch der Website (Server-Logfiles)</h2>
      <p>
        Beim Aufruf dieser Website werden durch unseren Hosting-Anbieter automatisch
        Daten in sogenannten Server-Logfiles gespeichert, die Ihr Browser übermittelt:
      </p>
      <ul>
        <li>Browsertyp und -version</li>
        <li>Verwendetes Betriebssystem</li>
        <li>Referrer-URL</li>
        <li>Anonymisierte IP-Adresse</li>
        <li>Uhrzeit der Serveranfrage</li>
      </ul>
      <p>
        Diese Daten werden nicht mit anderen Datenquellen zusammengeführt.
        Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
        technisch fehlerfreien Darstellung und Sicherheit der Website).
      </p>

      <h2>4. Kontaktformular</h2>
      <p>
        Wenn Sie uns über das Kontaktformular eine Anfrage zukommen lassen, werden Ihre
        Angaben aus dem Formular inklusive der von Ihnen dort angegebenen Kontaktdaten
        (Vorname, Nachname, E-Mail-Adresse, ggf. Telefonnummer) zwecks Bearbeitung der
        Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
      </p>
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Anbahnung eines Vertrags) sowie
        Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung von
        Anfragen). Die Daten werden gelöscht, sobald der Zweck der Verarbeitung entfällt
        und keine gesetzlichen Aufbewahrungsfristen entgegenstehen.
      </p>

      <h2>5. E-Mail-Versand über Resend</h2>
      <p>
        Für den Versand der Benachrichtigungs-E-Mails aus dem Kontaktformular nutzen wir
        den Dienst{" "}
        <strong>Resend (Resend, Inc., 2261 Market Street, San Francisco, CA 94114, USA)</strong>.
        Dabei werden die Inhalte Ihrer Anfrage (Name, E-Mail-Adresse, Telefon, Nachricht)
        an Server von Resend übermittelt. Resend ist als Auftragsverarbeiter im Sinne des
        Art. 28 DSGVO für uns tätig.
      </p>
      <p>
        Eine Übermittlung in die USA findet statt. Resend ist nach dem EU-US Data
        Privacy Framework zertifiziert; ergänzend wurden Standardvertragsklauseln
        abgeschlossen.
      </p>

      <h2>6. Hosting</h2>
      <p>
        Diese Website wird auf Servern eines externen Dienstleisters gehostet. Der Host
        verarbeitet personenbezogene Daten ausschließlich in unserem Auftrag (Art. 28
        DSGVO).
      </p>

      <h2>7. Externe Schriftarten</h2>
      <p>
        Auf dieser Website werden Schriften von <strong>Google Fonts</strong> (Google
        Ireland Ltd.) sowie <strong>Fontshare</strong> (Indian Type Foundry) eingebunden.
        Beim Aufruf einer Seite lädt Ihr Browser die benötigten Schriften und stellt
        dabei eine Verbindung zu den Servern dieser Anbieter her, wodurch Ihre
        IP-Adresse übermittelt wird. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO
        (einheitliche und ansprechende Darstellung der Inhalte).
      </p>

      <h2>8. Web-Analyse mit PostHog</h2>
      <p>
        Diese Website nutzt — sofern Sie eingewilligt haben — den Analysedienst{" "}
        <strong>PostHog</strong> (PostHog, Inc., USA) zur Reichweitenmessung und zur
        Verbesserung der Website. PostHog kann pseudonymisierte Daten zu Ihrem Verhalten
        auf der Seite erheben (z. B. besuchte Seiten, Klicks). Die Einwilligung erfolgt
        über unseren Cookie-Hinweis und kann jederzeit für die Zukunft widerrufen werden,
        indem Sie Ihre Auswahl im Cookie-Banner ändern.
      </p>
      <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).</p>

      <h2>9. Cookies & lokaler Speicher</h2>
      <p>
        Wir verwenden technisch notwendige Cookies und den lokalen Browser-Speicher,
        um z. B. Ihre Cookie-Entscheidung zu speichern (Rechtsgrundlage: Art. 6 Abs. 1
        lit. f DSGVO bzw. § 25 Abs. 2 TTDSG). Optionale Cookies (z. B. Analyse) werden
        nur mit Ihrer Einwilligung gesetzt.
      </p>

      <h2>10. Ihre Rechte als betroffene Person</h2>
      <p>
        Sie haben das Recht auf:
      </p>
      <ul>
        <li>Auskunft (Art. 15 DSGVO)</li>
        <li>Berichtigung (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch (Art. 21 DSGVO)</li>
        <li>Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
      </ul>
      <p>
        Außerdem haben Sie das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu
        beschweren. Zuständig für die Honex GmbH ist:{" "}
        <strong>
          Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen,
          Kavalleriestr. 2–4, 40213 Düsseldorf
        </strong>{" "}
        (<a href="https://www.ldi.nrw.de/" target="_blank" rel="noreferrer noopener">www.ldi.nrw.de</a>).
      </p>

      <h2>11. SSL-Verschlüsselung</h2>
      <p>
        Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
        vertraulicher Inhalte eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte
        Verbindung erkennen Sie an „https://“ in der Adresszeile Ihres Browsers.
      </p>

      <p className="mt-12 text-sm text-zinc-500">
        Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
      </p>
    </LegalLayout>
  );
}
